import { defineComponent as _defineComponent } from 'vue'
import Profile from "@/components/profile/Profile.vue";
import mailModule from "@/store/mail.module";
import authModule from "@/store/auth.module";
import { computed, onMounted, ref } from "vue";
import QrAppDialog from "@/components/ui/QrAppDialog.vue";
import { mdiQrcodeScan } from "@mdi/js";
import { ROLE_STORONA_IP } from "@/config/const";


const __default__ = {
  name: "CabinetHeader",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const qrDialog = ref(false);

const navigationItems = computed(() => {
  return [
    ...(authModule.isEmployer
      ? [
          {
            text: "Поступившие запросы",
            to: "/requests",
            hasInnerRoutes: true,
          },
          {
            text: "Сотрудники с постановлением о взыскании с З/П",
            to: "/employees-with-penalty",
          },
          {
            text: "Список постановлений о взыскании с З/П",
            to: { name: "WageOrders" },
            hasInnerRoutes: true,
          },
        ]
      : []),
    ...(authModule.isClaimant
      ? [
          { text: "Аналитика", to: "/claimant-analytics" },
          {
            text: "Исполнительные производства",
            to: "/claimant-productions",
          },
          {
            text: "Меры",
            to: "/claimant-arrests",
          },
          {
            text: "Мониторинг статуса ИП и принудительных мер",
            to: "/claimant-monitoring",
          },
        ]
      : []),
    ...(!authModule.isEmployer
      ? [
          {
            text: "notifications",
            to: "/notifications",
            hasInnerRoutes: true,
          },
          {
            text: "Исполнительные производства",
            to: "/exec-productions",
          },
          // {
          //   text: "Подача заявления ЧСИ",
          //   to: "/statements",
          //   hasInnerRoutes: true,
          // },
        ]
      : []),
    ...(authModule.onlyStoronaIp || authModule.storonaIpLeader
      ? [
          {
            text: "Повторное предъявление",
            to: "/resubmissions",
            hasInnerRoutes: true,
          },
        ]
      : []),
    ...(authModule.onlyStoronaIp || authModule.storonaIpLeader
      ? [
          {
            text: "Банковские реквизиты",
            to: "/bank-details",
            hasInnerRoutes: true,
          },
          {
            text: "Обращения",
            to: "/citizen-applications",
            hasInnerRoutes: true,
          },
        ]
      : []),
  ];
});

const mailCount = computed(() => {
  return mailModule.notificationsCount.unreadNotifications || "";
});

const appStoreDialog = async () => {
  qrDialog.value = true;
};

const freeUser = computed(() => {
  return authModule.roles.includes(ROLE_STORONA_IP);
});

onMounted(() => {
  if (freeUser.value) appStoreDialog();
});

return { __sfc: true,qrDialog, navigationItems, mailCount, appStoreDialog, freeUser, Profile, QrAppDialog, mdiQrcodeScan }
}

})